export default "/images/vendor/@coreui/icons/svg/flag/cif-dk.svg?1256f5ce4492668fe84d90bd1b081f94";